import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  NavController,
  NavParams,
  ModalController,
  ActionSheetController,
  AlertController,
  IonicModule,
  ToastController,
} from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { NomenclaturaPipe } from "src/app/pipes/nomenclatura/nomenclatura";
import { GrupoProvider } from "src/app/services/grupo/grupo";
@Component({
  selector: "app-grupo-filtro",
  templateUrl: "./grupo-filtro.page.html",
  styleUrls: ["./grupo-filtro.page.scss"],
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule, NomenclaturaPipe, TranslateModule, ReactiveFormsModule],
})
export class GrupoFiltroPage implements OnInit {
  validations_form: FormGroup;
  diaSemanaList: any = [
    { id: 0 || null, nome: this.translate.instant("TODOS") },
    { id: "1", nome: this.translate.instant("Domingo") },
    { id: "2", nome: this.translate.instant("Segunda-Feira") },
    { id: "3", nome: this.translate.instant("Terça-Feira") },
    { id: "4", nome: this.translate.instant("Quarta-Feira") },
    { id: "5", nome: this.translate.instant("Quinta-Feira") },
    { id: "6", nome: this.translate.instant("Sexta-Feira") },
    { id: "7", nome: this.translate.instant("Sábado") },
  ];

  tipos: any = [];
  regioes: any = [];
  filtro: any = {};
  tipo;
  filtroTipos: number | null;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public grupoProvider: GrupoProvider,
    public modalCtrl: ModalController,
    public actionSheetCtrl: ActionSheetController,
    public alertCtrl: AlertController,
    private translate: TranslateService,
    private formBuilder: FormBuilder,
    public toastCtrl: ToastController
  ) {
    this.filtro = this.navParams.get("filtro");
    this.tipo = this.navParams.get("tipo");
    this.filtroTipos = this.navParams.get("filtroTipos");
    this.filtro = this.filtro.data ? this.filtro.data : this.filtro;

    this.validations_form = this.formBuilder.group({
      dia: new FormControl(this.filtro.dia),
      tipo: new FormControl(this.filtro.tipo),
      regiao: new FormControl(this.filtro.regiao),
    });

    this.grupoProvider.getGruposTipos(this.tipo, this.filtroTipos).subscribe((data) => {
      this.tipos = data;
    });

    this.grupoProvider.getGruposRegiao().subscribe((data) => {
      this.regioes = data;
    });
  }

  ngOnInit() {}

  onSubmit(form: { tipo: number | null; dia: number | null; regiao: number | null }) {
    form.tipo = form.tipo === 0 ? null : form.tipo;
    form.dia = form.dia == 0 ? null : form.dia;
    form.regiao = form.regiao === 0 ? null : form.regiao;
    this.filtro = form;

    const nomeTipo = this.tipos.find((t: any) => t.id === form.tipo)?.nome;
    const nomeRegiao = this.regioes.find((r: any) => r.id === form.regiao)?.nome;
    this.modalCtrl.dismiss({
      tipo: form.tipo,
      regiao: form.regiao,
      dia: form.dia,
      nomeTipo,
      nomeRegiao,
    });
  }

  public closeModal() {
    this.modalCtrl.dismiss(false);
  }

  getNomenclatura(tipo: string) {
    const tipoMap: Record<string, string> = {
      "2": "ministerios",
      "3": "ebds",
    };

    return tipoMap[tipo] || "grupos";
  }

  onCancel() {
    this.reloadTypes(true, null);
  }

  reloadTypes(reload: boolean, validation: number | null) {
    this.grupoProvider.getGruposTipos(this.tipo, this.filtroTipos).subscribe((data) => {
      this.tipos = data;

      if (!reload && validation) {
        this.validateTypeExists(validation);
      }
    });
  }

  private validateTypeExists(validation: number) {
    const tipoExistente = this.tipos.some((element: { id: number }) => element.id === validation);

    if (!tipoExistente) {
      const message = this.translate.instant(
        "Atenção! O tipo selecionado não está mais ativo. Por favor, escolha uma opção diferente."
      );

      this.validations_form.get("tipo")?.patchValue(null);

      this.showToast(message);
    } else {
      this.modalCtrl.dismiss(this.filtro);
    }
  }

  private async showToast(message: string) {
    const toast = await this.toastCtrl.create({
      message: message,
      duration: 4000,
    });

    toast.present();
  }
}
